// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2RKdJ","content":"Consent_content__FCSOW","footer":"Consent_footer__21Zsx"};